module.exports = __webpack_public_path__ + "static/zuri-81183b5ccc94509b3922c1b05752eec3.png";